module.exports = __webpack_public_path__ + "static/media/kerry-diocesan-youth-service.ae8bc913.jpg";